export default __webpack_public_path__ + "static/media/blog-img158.5a12ffca.jpg";